import { PaginationProps } from "antd";
import { StyledPagination } from "./atom";
import { ConfigProvider } from "antd";
import { PropsWithChildren } from "react";
import i18next from "i18next";
import zhCN from "antd/locale/zh_CN";
import enUS from "antd/locale/en_US";
import { SimpleInterpolation } from "styled-components";

export type RenderbusPaginationProps = PropsWithChildren<
  PaginationProps & {
    inTable?: boolean;
    gap?: boolean;
    customCSS?: SimpleInterpolation;
  }
>;

export function Pagination({
  className = "",
  total,
  showQuickJumper,
  showSizeChanger,
  onChange,
  inTable,
  gap = true,
  customCSS,
  ...props
}: RenderbusPaginationProps) {
  const inTableClassName = inTable ? "renderbus-ui--pagination__in-table" : "";
  const gapClassName = gap ? "renderbus-ui--pagination__in-table__gap" : "";
  return (
    <ConfigProvider locale={i18next.language === "zh" ? zhCN : enUS}>
      <StyledPagination
        className={`renderbus-ui--pagination ${inTableClassName} ${gapClassName} ${className}`}
        showQuickJumper={showQuickJumper}
        showSizeChanger={showSizeChanger}
        defaultCurrent={1}
        total={total}
        onChange={onChange}
        customCSS={customCSS}
        {...props}
      />
    </ConfigProvider>
  );
}
